; (() => {
    function mouseDragX(wrapper, dragSpeed = 1.5) {
        let isDown = false
        let startX = 0
        let scrollLeft = 0
        const dragClass = 'js-dragging'

        wrapper.addEventListener('mousedown', e => {
            isDown = true
            wrapper.classList.add(dragClass)
            startX = e.pageX - wrapper.offsetLeft
            scrollLeft = wrapper.scrollLeft
        })

        wrapper.addEventListener('mouseleave', () => {
            isDown = false
            wrapper.classList.remove(dragClass)
        })

        wrapper.addEventListener('mouseup', () => {
            isDown = false
            wrapper.classList.remove(dragClass)
        })

        wrapper.addEventListener('mousemove', e => {
            if (!isDown) return
            e.preventDefault()
            const x = e.pageX - wrapper.offsetLeft
            const walk = (x - startX) * dragSpeed
            wrapper.scrollLeft = scrollLeft - walk
            wrapper.dispatchEvent(new Event('drag-y'))
        })
    }

    function mouseDragY(wrapper, dragSpeed = 1) {
        let isDown = false
        let startY = 0
        let scrollTop = 0
        const dragClass = 'js-dragging'
        const enableWheelEvent = wrapper.dataset.hasOwnProperty('wheelEvent')

            ;['mousedown', 'touchstart'].forEach(event => {
                wrapper.addEventListener(event, e => {
                    isDown = true
                    wrapper.classList.add(dragClass)
                    startY = (e.pageY || e.changedTouches[0]?.pageY || 0) - wrapper.offsetTop
                    scrollTop = wrapper.scrollTop
                })
            })

            ;['mouseleave', 'mouseup', 'touchend'].forEach(event => {
                wrapper.addEventListener(event, () => {
                    isDown = false
                    wrapper.classList.remove(dragClass)
                })
            })

            ;['mousemove', 'touchmove'].forEach(event => {
                wrapper.addEventListener(event, e => {
                    if (!isDown) return
                    e.preventDefault()
                    const y = (e.pageY || e.changedTouches[0]?.pageY || 0) - wrapper.offsetTop
                    const walk = (y - startY) * dragSpeed
                    wrapper.scrollTop = scrollTop - walk
                    wrapper.dispatchEvent(new Event('drag-y'))
                })
            })

        if (enableWheelEvent) {
            wrapper.addEventListener('wheel', e => {
                wrapper.scrollTop = wrapper.scrollTop + e.deltaY / 3
                wrapper.dispatchEvent(new Event('wheel-y'))
            })
        }
    }

    window.addEventListener('load', () => {
        document.querySelectorAll('.js-mouse-drag').forEach(draggable => {
            mouseDragX(draggable)
        })

        document.querySelectorAll('.js-mouse-drag-y').forEach(draggable => {
            mouseDragY(draggable)
        })
    })
})();